<template>
    <div>
        <headerBackground v-bind="headerData" />
        <div class="container">
            <div class="row">
                <div class="col-md-12 mx-auto">
                    <div class="pb-5 text-start">
                        <h2 @click="goBack" class="go-back">Назад</h2>
                    </div>
                    <table class="table text-start">
                        <thead>
                            <tr>
                                <th style="width:40%">Курс</th>
                                <th style="width:40%">Тест</th>
                                <th>Результат</th>
                                <th>Дата</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(grade, index) in grades" :key="'grade' + index">
                                <td>
                                    {{ grade.courses_name }}
                                </td>
                                <td>
                                    {{ grade.name }}
                                </td>
                                <td><b :style="((grade.correct / grade.total) * 100) > 50 ? 'color: green;' : 'color: red;'">
                      {{ grade.correct }} из {{ grade.total }}<br/> <span v-if="((grade.correct / grade.total) * 100) > 0">{{ Math.round((grade.correct / grade.total) * 100) }}% </span>
                      <span v-else>0%</span>
                    </b></td>
                                <td>
                                    {{ grade.created_at }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <cabinetFooter />
    </div>
</template>

<script>
import headerBackground from '@/components/headerBackground.vue'
import cabinetFooter from '@/components/cabinetFooter.vue'
// import md5 from 'js-md5'
// import { Base64 } from 'js-base64';

export default {
    components: {
        headerBackground,
        cabinetFooter
    },
    data() {
        return {
            warning: null,
            grades: null,
            headerData: {
                name: 'Оценки'
            }
        }
    },
    mounted() {
        if (this.grades === null) {
            this.axios
                .get(this.$store.getters.URL + '/api/grades/')
                .then(response => (this.grades = response.data.grades,
                    this.$store.commit('reDirect', response.data.redirect)
                ));
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style>

</style>
